export default "__VITE_ASSET__BhrrPUp2__"